import React, { /* useEffect, */ useState } from 'react'
import { useDispatch, useSelector } from 'react-redux';

// import makeRequest from '../../../../actions/makeRequest';
// import { getRequest } from './requests';
import ConfirmationModal from '../../../../components_new/modals/SimpleConfirmationModal';
import { handleChange, submitFunction, submitValidation } from './events';
import { voucherState, errorState, modalState } from './states';


const OTVoucherReportsForm = () => {
    const dispatch = useDispatch();
    const {rmaCollection} = useSelector(state => state.ot)

    const [voucher, setVoucher] = useState(voucherState);
    const [error, setError] = useState(errorState);
    const [modal, setModal] = useState(modalState);

    const {
        date_from,
        date_to,
    } = voucher

    const submitSetup = { voucher, rmaCollection, setVoucher, setError, dispatch }

    const aux = {
        show: modal.modalShow,
        onHide:() => setModal({
            ...modal,
            modalShow: false,
        }),
        fnToInvoke: () => submitFunction(submitSetup),
        modalSize : 'md',
        backdrop : 'static',
        modalText: 'Para confirmar el envío de información para generas un nuevo reporte Voucher OT, por favor presione en -Enviar-'
    }

    const submit = e => {
        e.preventDefault()
        const {status, message} = submitValidation({voucher,rmaCollection})
        if(status) {
            return setError({status,message})
        }

        setModal({
            ...modal,
            modalShow: true,
        })
    }
    /* useEffect(() => {
      dispatch(makeRequest(getRequest))
    }, [dispatch]) */
    return (
        <form className='ot_search_form'>

            <div>
                <p className="panel_cliente_crear_ticket_nuevo">Reporte Voucher OT</p>
                <div className="panel_cliente_crear_ticket_inputs">
                    <div className="voucher_input_container ot_watchmaker_input_to_derive dates">
                        <small>Rango de fechas</small>
                        <input
                            type='date'
                            name='date_from'
                            id='voucher_input_2'
                            value={date_from}
                            onChange={e => handleChange(setVoucher,e)}
                        />
                        <input
                            type='date'
                            name='date_to'
                            id='voucher_input_3'
                            value={date_to}
                            onChange={e => handleChange(setVoucher,e)}
                        />
                    </div>

                </div>
            </div>
            <div className='ot_button_group_1'>

                <button
                    onClick={submit}
                    className='ot_create_button green'
                >
                    <small>Obtener reporte Vouchers</small>
                </button>

                <button
                    onClick={(e) => {
                        e.preventDefault()
                        setVoucher(voucherState)
                    }}
                    className='ot_create_button red1'
                >
                    <small>Vaciar formulario</small>
                </button>
            </div>
            <br />

            <ConfirmationModal
                {...aux}
            />
        </form>
    )

}

export default OTVoucherReportsForm
